'use client';

import { useSelector } from 'react-redux';
import { HugeiconsIcon } from '@hugeicons/react';
import { Car04Icon, DiscountIcon } from '@hugeicons/core-free-icons';
import { TbCoinTaka } from 'react-icons/tb';
import { PromoBannerSlider } from './PromoBannerSlider';
import type { RootState } from '@/lib/redux/store';

const PromoBanner = () => {
  const { generalSettings } = useSelector((state: RootState) => state.settings);

  const settings = generalSettings ?? [];
  const shippingCost =
    settings.find((item: any) => item.type === 'min_amount_free_shipping')
      ?.value ?? 'N/A';
  const minShippingAmount =
    settings.find((item: any) => item.type === 'default_shipping_cost')
      ?.value ?? 'N/A';

  const promoItems = [
    {
      icon: <HugeiconsIcon icon={Car04Icon} size={48} />,
      title: `Free Shipping on Orders Over ${shippingCost} BDT`,
      subtitle: 'For All Products',
    },
    {
      icon: <TbCoinTaka size={48} />,
      title: 'Up To 10% OFF On All Items',
      subtitle: 'Available for J-Beauty Users Group!',
      link: 'https://www.facebook.com/groups/520245052204738',
    },
    {
      icon: <HugeiconsIcon icon={DiscountIcon} size={48} />,
      title: `Flat ${minShippingAmount} TK delivery charge`,
      subtitle: 'All over the country!',
    },
  ];

  return (
    <div className="promo-banner">
      <div className="container">
        <PromoBannerSlider items={promoItems} />
      </div>
    </div>
  );
};

export default PromoBanner;
